import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/AuthContext.jsx'
import './Login.css'

const Login = () => {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const { signIn } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!email || !password) {
      setError(t('errors.invalidLogin'))
      return
    }

    setLoading(true)
    setError('')

    try {
      const { error } = await signIn(email, password)
      
      if (error) {
        console.error('Login error:', error)
        setError(error.message)
      }
      // Success handled by AuthContext - user will be redirected
    } catch (err) {
      console.error('Unexpected login error:', err)
      setError(t('errors.unexpectedLoginError'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Logo section */}
        <div className="login-header">
          <div className="login-logo">
            <img src="/revetall-icon.svg" alt="Revetall Logo" className="login-logo-icon" />
            <div className="login-logo-text">
              <h1><img src="/revetall-logo.svg" alt="Revetall" className="login-wordmark" /></h1>
              <span className="login-tagline">{t('auth.tagline')}</span>
            </div>
          </div>
        </div>

        {/* Login form */}
        <form onSubmit={handleSubmit} className="login-form">
          <h2>{t('auth.login')}</h2>
          
          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">{t('auth.email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('auth.emailPlaceholder')}
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t('auth.password')}</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('auth.passwordPlaceholder')}
              disabled={loading}
              required
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? t('auth.loggingIn') : t('auth.login')}
          </button>
        </form>

        <div className="login-footer">
          <p>{t('auth.contactMessage')} <a href="mailto:post@revetall.ai">post@revetall.ai</a></p>
        </div>
      </div>
    </div>
  )
}

export default Login
